import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function fetchDashboardLayout() {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/dashboard/layout`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function createNewDashboardLayout(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/dashboard/layout`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function setDefaultLayout(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/dashboard/layout/set-active`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function updateLayout(id, data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.put(`${APP_API_URL_V2}/dashboard/layout/${id}`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchDashboardCardData(card_id, params = {}) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/dashboard/cards/${card_id}`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchDashboardCards() {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/dashboard/cards`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function getGettingStarted() {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/onboarding/`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function skipModule(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/onboarding/mark-as-completed`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function updateStatusNotification(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/notifications/update-status`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function getNotifications(params) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/notifications/`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function getNotificationsUnreadCounts() {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/notifications/unread-counts`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
